import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  InitialQuestionModalComponent
} from '@domain/meeting/components/initial-question-modal/initial-question-modal.component';
import { MeetingQuestionComponent } from '@domain/meeting/components/meeting-question/meeting-question.component';
import {
  MeetingRatingDescriptionModalComponent
} from '@domain/meeting/components/meeting-rating-description-modal/meeting-rating-description-modal.component';
import { SharedModule } from '@shared/shared.module';
import { RatingSelectorComponent } from 'app/ui/rating-selector/rating-selector.component';

@NgModule({
  declarations: [
    InitialQuestionModalComponent,
    MeetingQuestionComponent,
    MeetingRatingDescriptionModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    RatingSelectorComponent
  ]
})
export class MeetingModule {
}
